import { render, staticRenderFns } from "./RiskIndexObservationsDetail.vue?vue&type=template&id=f2b9c690&scoped=true"
import script from "./RiskIndexObservationsDetail.vue?vue&type=script&lang=js"
export * from "./RiskIndexObservationsDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskIndexObservationsDetail.vue?vue&type=style&index=0&id=f2b9c690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b9c690",
  null
  
)

export default component.exports